import { lazyWithRetry } from "utils/lazy-with-retry";
import { ISharePointCallbackProps } from "./definitions";

const LazySharePointCallback = lazyWithRetry(
  () => import("./SharePointCallback"),
);

const SharePointCallback = (props: ISharePointCallbackProps) => (
  <LazySharePointCallback {...props} />
);

export default SharePointCallback;
